var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFreeVersioninline = function SvgFreeVersioninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BB66E1",
    d: "M23.562 26.507A10.112 10.112 0 0 0 28 18.115C28 12.54 23.523 8.02 18 8.02S8 12.54 8 18.115c0 3.498 1.762 6.58 4.438 8.392l-.8 1.883A12.133 12.133 0 0 1 6 18.115C6 11.425 11.373 6 18 6s12 5.424 12 12.115c0 4.332-2.252 8.133-5.639 10.275l-.799-1.883Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB66E1",
    d: "M22 18.115a4.046 4.046 0 0 1-2.574 3.775l2.765 6.511c.215.508.797.75 1.284.498.303-.157.599-.327.886-.509l-2.421-5.706A6.068 6.068 0 0 0 24 18.115c0-3.345-2.686-6.057-6-6.057s-6 2.712-6 6.057c0 1.824.798 3.459 2.06 4.57l.85-2.004a4.046 4.046 0 0 1-.91-2.566c0-2.23 1.79-4.038 4-4.038s4 1.808 4 4.038Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB66E1",
    d: "M16.574 21.89 13.81 28.4c-.216.508-.798.75-1.285.498a11.744 11.744 0 0 1-.886-.509l3.272-7.709a4.01 4.01 0 0 0 1.663 1.209Z"
  })));
};
export default SvgFreeVersioninline;